var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('a-select',{staticStyle:{"width":"300px"},on:{"change":function (val) { return _vm.handleChange(val); }}},_vm._l((_vm.avatarOptions),function(option,index){return _c('a-select-option',{key:index,attrs:{"value":option.value}},[_vm._v("\n        "+_vm._s(option.label)+"\n      ")])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e32da4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/userAvatarDropDown.vue
// module id = null
// module chunks = 